export const getSubscriptionBannerMessage = (user) => {
  if (user?.is_trial_expired || user?.subscription_status === 'expired') {
    return 'Your Starter Trial has ended. The app is in read-only mode and Caleb AI is paused until you activate a paid plan.';
  }
  return 'Your subscription is inactive. You have read-only access. Activate a paid plan to restore full access and Caleb AI.';
};

export const getCalebPausedMessage = (user) => {
  if (user?.is_trial_expired || user?.subscription_status === 'expired') {
    return 'Caleb AI is paused because your Starter Trial has ended. Activate a paid plan to resume AI assistance.';
  }
  return 'Caleb AI is unavailable while your subscription is inactive. You still have read-only access to your data.';
};
